import axios from "axios"

const url = process.env.REACT_APP_URL

export const setModelSettings = async (newModel: boolean) => {
  try {
    const res = await axios.post(`${url}/model/config`, {
      newModel
    })
    return res.data
  } catch (err) {
    console.log(err)
    return err
  }
}

export const getModelSettings = async () => {
  try {
    const res = await axios.get(`${url}/model/config`)
    return res.data
  } catch (err) {
    console.log(err)
    return null
  }
}